/**
 * Observes DOM mutations to detect when the reCAPTCHA challenge iframe is added,
 * then repositions it so it appears above other page elements.
 * @returns {Function} Cleanup function that disconnects the MutationObserver.
 */
export function recaptchaChallengeObserver() {
	const $targetNode = document.body;
	const observerConfig = { attributes: false, childList: true, subtree: true };

	const callback = (mutationList) => {
		for (const mutation of mutationList) {
			if (mutation.type === 'childList' && 'addedNodes' in mutation) {
				const isRecaptchaContainer = Array.from(mutation.addedNodes).some(x => {
					return x instanceof HTMLElement && x.tagName === 'DIV' && x.querySelector('iframe[title*=recaptcha]') != null;
				});

				if (isRecaptchaContainer) {
					const $challengeContainer = document.querySelector('[title*="challenge"]');
					if ($challengeContainer) {
						const $challengeParent = $challengeContainer.parentElement?.parentElement;
						if ($challengeParent) {
							$challengeParent.style.position = 'fixed';
							$challengeParent.style.zIndex = '100000';
						}
					}
				}
			}
		}
	};

	const observer = new MutationObserver(callback);
	observer.observe($targetNode, observerConfig);

	return () => observer.disconnect();
}
